import '../../App.css'
// import HeroSection from '../HeroSection'
import React from 'react'
// import Cards from '../Cards'
import MeetTheTeam from '../MeetTheTeam'
import GraphicCompanyScrolling from '../GraphicCompanyScrolling';
import GraphicHomePage from '../AltHomePage'


function Home(){
    return (
        <>
            {/* <HeroSection></HeroSection> */}
            <GraphicHomePage></GraphicHomePage>
            <GraphicCompanyScrolling></GraphicCompanyScrolling>
            <MeetTheTeam></MeetTheTeam>
        </>
    )
}

export default Home